// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"193":"ce2e8346","591":"aa0051fd"}[chunkId] + ".css";
};